// src/components/InputField.tsx

import React from "react";

interface CountryOption {
  code: string;
  name: string;
}

interface PhoneInputFieldProps {
  label: string;
  placeholder?: string;
  required?: boolean;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  countryOptions: CountryOption[];
  selectedCountryCode: string;
  onCountryChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  className?: string;
}

const PhoneInputField: React.FC<PhoneInputFieldProps> = ({
  label,
  placeholder,
  required,
  value,
  onChange,
  countryOptions,
  selectedCountryCode,
  onCountryChange,
  className,
}) => {
  return (
    <div className={`mb-6 ${className}`}>
      <label className="text-base font-normal leading-[1.625rem]">
        {label}
        {required && <span className="ml-1 text-red-500">*</span>}
      </label>
      <div className="mt-2 flex">
        {/* Country Code Dropdown */}
        <select
          value={selectedCountryCode}
          onChange={onCountryChange}
          className="mr-[0.625rem] h-[3.125rem] min-w-[6rem] rounded-[0.625rem] border border-[#DCDCDC] bg-white p-2 text-base leading-[1.375rem] text-[#5E6D77]"
        >
          {countryOptions.map((country) => (
            <option key={country.code} value={country.code}>
              {country.code}
            </option>
          ))}
        </select>

        {/* Phone Number Input */}
        <input
          type="text"
          placeholder={placeholder}
          className="h-[3.125rem] w-full rounded-[0.625rem] border border-[#DCDCDC] p-3 text-base font-normal leading-[1.375rem] text-[#5E6D77]"
          value={value}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

export default PhoneInputField;
